module.exports = __webpack_public_path__ + "static/img/pomok.29c55c65.webp";